import { useMemo } from "react";

import { type Page, type PageId, findPageForPath, Pages } from "../constants";

type PathConfig = {
  readonly pathname: string;
  readonly page?: never;
};

type PageConfig = {
  readonly pathname?: never;
  /* The page can be determined based on a provided string path. However, we still allow the page
     to be defined explicitly - for purposes of flexibility and avoiding conditional hook usage. */
  readonly page: Page | PageId;
};

export type UsePageConfig = PageConfig | PathConfig;

export const usePage = ({ pathname, page }: UsePageConfig): Page | null =>
  useMemo<Page | null>((): Page | null => {
    if (pathname === undefined) {
      return typeof page === "string" ? Pages.getModel(page) : page;
    }
    const pg = findPageForPath(pathname, { strict: false });
    if (!pg) {
      /* eslint-disable-next-line no-console */
      console.error(
        `No page found for ${pathname}. To use this page, the path must be defined with ` +
          "a 'pathMatch' value in @nb-client-side/pages.",
      );
      return null;
    }
    return pg;
  }, [page, pathname]);
